import React from 'react';
import { products } from '../data/products';
import { ProductCard } from '../components/ProductCard';
export function Shop() {
  return <div className="py-12 px-4 max-w-7xl mx-auto w-full" data-id="element-365">
      <div className="mb-12" data-id="element-366">
        <h1 className="font-display text-5xl md:text-6xl tracking-wide mb-4" data-id="element-367">
          Shop All
        </h1>
        <p className="text-neutral-400 max-w-2xl" data-id="element-368">
          The complete VSC Clothing collection. Premium materials,
          uncompromising fit, designed in Louisville.
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-369">
        {products.map(product => <ProductCard key={product.id} product={product} data-id="element-370" />)}
      </div>
    </div>;
}